import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ListaService } from '../../../_services/lista.service';
import { ListaItem } from '../../../_models/lista-item';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { NavService } from '../../../_services/_nav.service';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { Campania } from '../../../_models/campania';
import { CampaniaDescuentoDestino } from '../../../_models/campania-descuento-destino';
import { Funcionalidad } from '../../../_models/funcionalidad';
import { CampaniaDescuentoDestinoService } from '../../../_services/campania-descuento-destino.service';

@Component( {
  selector: 'app-campania-descuento-destino',
  templateUrl: 'campania-descuento-destino.component.html'
} )

export class CampaniaDescuentoDestinoComponent implements OnInit {

  @Input() campania: Campania;
  formulario: FormGroup;
  campaniaDescuento: CampaniaDescuentoDestino;

  /** Listas */
  lisCampaniasDescuento: CampaniaDescuentoDestino[] = [];
  lisDestinosTodos: ListaItem[] = [];
  lisDestinos: SelectItem[] = [];

  columnas: any[] = [];
  carInformacionInicial = true;
  tabSeleccionado = 'VARIABLE';
  submitted = false;
  guardando = false;
  carTabla = true;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();


  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private serCampaniaDescuento: CampaniaDescuentoDestinoService,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private serLista: ListaService
  ) {
  }

  ngOnInit() {

    if ( this.campania && (this.campania.idCampania !== null && this.campania.idCampania !== '' && this.campania.idCampania !== undefined) ) {
      /** Se carga las campanias */
      this.serCampaniaDescuento.obtenerPorCampania( this.campania.idCampania ).subscribe( registros => {
        this.lisCampaniasDescuento = registros;
        this.cargarInformacionInicial();
      } );
    }

  }

  cargarInformacionInicial() {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/campania' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'nombreDestino', header: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.LBL_DESTINO' ), sort: true },
      { field: 'descuentoTasa', header: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.LBL_DESCUENTOTASA' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.cargarFormulario();

    this.serLista.getMasterDetails( 'ListasDestinosProductos' ).subscribe( destinos => {
      this.lisDestinosTodos = destinos;
      this.lisDestinosTodos.map( ( s: ListaItem ) => {
        if ( !this.lisCampaniasDescuento.find( x => x.idDestino === s.idLista && x.indicadorHabilitado ) ) {
          this.lisDestinos.push( { label: s.nombre, value: s.idLista } );
        }
      } );
      this.carTabla = false;
      this.carInformacionInicial = false;
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idCampaniaDescuentoDestino: [ this.campaniaDescuento ? this.campaniaDescuento.idCampaniaDescuentoDestino : null ],
      idCampania: [ this.campania ? this.campania.idCampania : null, [ Validators.required ] ],
      idDestino: [ this.campaniaDescuento ? this.campaniaDescuento.idDestino : null, [ Validators.required ] ],
      descuentoTasa: [ this.campaniaDescuento ? this.campaniaDescuento.descuentoTasa : null, [ Validators.required ] ],
      indicadorSuma: [ this.campaniaDescuento ? this.campaniaDescuento.indicadorSuma : false, [ Validators.required ] ],
      indicadorHabilitado: [ this.campaniaDescuento ? this.campaniaDescuento.indicadorHabilitado : true, [ Validators.required ] ]
    } );
  }

  recargarDestinos() {
    this.lisDestinos = [];
    this.lisDestinosTodos.map( ( s: ListaItem ) => {
      if ( !this.lisCampaniasDescuento.find( x => x.idDestino === s.idLista && x.indicadorHabilitado ) ) {
        this.lisDestinos.push( { label: s.nombre, value: s.idLista } );
      }
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  recargarCampaniasDescuento() {
    this.lisCampaniasDescuento = [];
    /** Se carga las campanias */
    this.serCampaniaDescuento.obtenerPorCampania( this.campania.idCampania ).subscribe( registros => {
      this.lisCampaniasDescuento = registros;
      this.recargarDestinos();
      this.carTabla = false;
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      this.carTabla = true;
      const formulario = this.formulario.getRawValue();
      const existeRegistro = this.lisCampaniasDescuento.find( y => y.idDestino === formulario.idDestino && !y.indicadorHabilitado );
      if ( formulario.idCampaniaDescuentoDestino ) {
        /** Actualizar Camapaña descuento */
        this.serCampaniaDescuento.actualizar( formulario ).subscribe( regAct => {
          this.recargarCampaniasDescuento();
          this.finalizarGuardado();
          this.navServicio.setMesage( 0, {
            severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.MSG_REGACTU' )
          } );
        } );
      } else {
        /** Crear Camapaña descuento */
        if ( existeRegistro && (existeRegistro.idCampaniaDescuentoDestino !== null && existeRegistro.idCampaniaDescuentoDestino !== '' && existeRegistro.idCampaniaDescuentoDestino !== undefined) ) {
          formulario.idCampaniaDescuentoDestino = existeRegistro.idCampaniaDescuentoDestino;
          formulario.indicadorHabilitado = true;
          this.serCampaniaDescuento.actualizar( formulario ).subscribe( regAct => {
            this.recargarCampaniasDescuento();
            this.finalizarGuardado();
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.MSG_REGCREA' )
            } );
          } );
        } else {
          this.serCampaniaDescuento.crear( formulario ).subscribe( reg => {
            this.recargarCampaniasDescuento();
            this.finalizarGuardado();
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.MSG_REGCREA' )
            } );
          } );
        }
      }

    }
  }

  finalizarGuardado() {
    this.campaniaDescuento = null;
    this.formulario.reset();
    this.cargarFormulario();
    this.guardando = false;
    this.submitted = false;
  }

  editar( reg: CampaniaDescuentoDestino ) {
    this.campaniaDescuento = reg;
    this.formulario.reset();
    this.cargarFormulario();
  }

  eliminar( item: CampaniaDescuentoDestino ) {
    item.indicadorHabilitado = false;
    this.serCampaniaDescuento.actualizar( item ).subscribe( regAct => {
      this.lisCampaniasDescuento.map( ( s: CampaniaDescuentoDestino ) => {
        if ( item.idCampaniaDescuentoDestino === s.idCampaniaDescuentoDestino ) {
          s.indicadorHabilitado = false;
        }
      } );
      this.recargarDestinos();
      this.navServicio.setMesage( 0, {
        severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'CAMPANIADCTODESTINO.MSG_REGELIM' )
      } );
    } );
  }

  obtenerCampaniasDescuentoHabilitadas() {
    return this.lisCampaniasDescuento.filter( x => x.indicadorHabilitado );
  }

}
